import Sounds from "./webAudio";

// Create a centralized sound manager instance that all files can use
export const soundManager = new Sounds();

// Load all sounds
soundManager.loadSound("move", "/audio/piece-move.mp3");
soundManager.loadSound("select", "/audio/menu-select.mp3");
soundManager.loadSound("click", "/audio/menu-click.mp3");
soundManager.loadSound("VictoryAudio", "/audio/victoryC-audio.mp4");

export const setMoveSoundVolume = (volume: number) => {
    // Prevent NaN, undefined, or out-of-bounds values from crashing the player
    const v = Math.max(0, Math.min(1, isFinite(volume) ? volume : 0.5));
    soundManager.setMasterVolume(v);
};

export const playMoveSound = () => {
    soundManager.play("move");
};
